var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FDB528"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white",
    fillOpacity: 0.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0773 12H14.9227V14.0175H18.5037C19.8188 14.0175 20.9404 14.8608 21.3568 16.0349H14.9227V18.0524H21.3568C20.9404 19.2266 19.8188 20.0699 18.5037 20.0699H14.9227V22.0873L20.8353 28L22.2618 26.5734L17.7758 22.0874H18.5037C20.9394 22.0874 22.9774 20.3518 23.446 18.0524H25.0773V16.035H23.446C23.2942 15.29 22.9775 14.6042 22.5361 14.0175H25.0773V12Z",
    fill: "#F7B329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee1);
export default __webpack_public_path__ + "static/media/rupee1.8ac92291bb2d7b4a10aae783c0a38f70.svg";
export { ForwardRef as ReactComponent };